import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
	reduxForm,
	Field,
	formValueSelector,
	getFormValues
} from 'redux-form';

import ContentCard from '../common/template/contentCard';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import InputPesquisa from '../common/form/inputPesquisa';

import {
	setModoTela
} from './perfilAcessoActions';

class PerfilAcessoForm extends Component {

	state = {
		pesquisar: ''
	}

	atualizarJsonAcesso(jsonAcesso) {
		this.props.change('json_acesso', jsonAcesso);
	}

	getJsonAcesso() {
		return (
			this.props.formularioValues
			&& this.props.formularioValues.json_acesso
		) || [];
	}

	moduloSelecionado(modulo) {

		const jsonAcesso = this.getJsonAcesso();

		return jsonAcesso.filter(
			acesso => acesso.id_modulo == modulo.id
		).length > 0;
	}

	telaSelecionada(modulo, tela) {

		const jsonAcesso = this.getJsonAcesso();

		return jsonAcesso.filter(acesso =>
			acesso.id_modulo == modulo.id
			&& (acesso.telas || []).filter(
				acessoTela =>
					acessoTela.id_tela == tela.id
			).length
		).length > 0;
	}

	permissaoSelecionada(modulo, tela, permissao) {

		const jsonAcesso = this.getJsonAcesso();

		return jsonAcesso.filter(acesso =>
			acesso.id_modulo == modulo.id
			&& (acesso.telas || []).filter(
				acessoTela =>
					acessoTela.id_tela == tela.id
					&& (acessoTela.permissoes || []).filter(
						acessoPermissao =>
							acessoPermissao.id_permissao == permissao.id
					).length
			).length
		).length > 0;
	}

	alterarModulo(modulo) {

		let jsonAcesso = this.getJsonAcesso().map(item => ({
			...item,
			telas: (item.telas || []).map(tela => ({
				...tela,
				permissoes: (tela.permissoes || []).map(permissao => ({
					...permissao
				}))
			}))
		}));

		if (this.moduloSelecionado(modulo)) {

			jsonAcesso = jsonAcesso.filter(
				acesso => acesso.id_modulo != modulo.id
			);

		} else {

			jsonAcesso.push({
				id_modulo: modulo.id,
				telas: (modulo.telas || [])
					.filter(tela => tela)
					.map(tela => ({
						id_tela: tela.id,
						permissoes: (tela.permissoes || [])
							.filter(permissao => permissao)
							.map(permissao => ({
								id_permissao: permissao.id
							}))
					}))
			});
		}

		this.atualizarJsonAcesso(jsonAcesso);
	}

	alterarTela(modulo, tela) {

		let jsonAcesso = this.getJsonAcesso().map(item => {

			if (item.id_modulo != modulo.id) {
				return item;
			}

			const telaJaSelecionada = (item.telas || []).filter(
				acessoTela =>
					acessoTela.id_tela == tela.id
			).length > 0;

			if (telaJaSelecionada) {

				return {
					...item,
					telas: (item.telas || []).filter(
						acessoTela =>
							acessoTela.id_tela != tela.id
					)
				};

			}

			return {
				...item,
				telas: [
					...(item.telas || []),
					{
						id_tela: tela.id,
						permissoes: (tela.permissoes || [])
							.filter(permissao => permissao)
							.map(permissao => ({
								id_permissao: permissao.id
							}))
					}
				]
			};
		});

		this.atualizarJsonAcesso(jsonAcesso);
	}

	alterarPermissao(modulo, tela, permissao) {

		let jsonAcesso = this.getJsonAcesso().map(item => {

			if (item.id_modulo != modulo.id) {
				return item;
			}

			return {
				...item,
				telas: (item.telas || []).map(acessoTela => {

					if (acessoTela.id_tela != tela.id) {
						return acessoTela;
					}

					let permissoes = (acessoTela.permissoes || [])
						.map(acessoPermissao => ({
							...acessoPermissao
						}));

					const possui = permissoes.filter(
						acessoPermissao =>
							acessoPermissao.id_permissao == permissao.id
					).length > 0;

					if (possui) {

						permissoes = permissoes.filter(
							acessoPermissao =>
								acessoPermissao.id_permissao != permissao.id
						);

					} else {

						permissoes.push({
							id_permissao: permissao.id
						});
					}

					return {
						...acessoTela,
						permissoes
					};
				})
			};
		});

		this.atualizarJsonAcesso(jsonAcesso);
	}

	marcarTodos() {

		const jsonAcesso = (this.props.listaModulo || []).map(modulo => ({
			id_modulo: modulo.id,
			telas: (modulo.telas || [])
				.filter(tela => tela)
				.map(tela => ({
					id_tela: tela.id,
					permissoes: (tela.permissoes || [])
						.filter(permissao => permissao)
						.map(permissao => ({
							id_permissao: permissao.id
						}))
				}))
		}));

		this.atualizarJsonAcesso(jsonAcesso);
	}

	desmarcarTodos() {

		this.atualizarJsonAcesso([]);
	}

	getListaFiltrada() {

		return (this.props.listaModulo || []).filter(modulo => {

			return !(this.state.pesquisar || '').trim()
				|| (this.state.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(pesquisar => (pesquisar || '').trim())
					.filter(pesquisar => {

						if (
							pesquisar
							&& !(`
								${modulo.nome || ''}

								${(modulo.telas || [])
									.filter(tela => tela)
									.map(tela => `
										${tela.nome || ''}

										${(tela.permissoes || [])
											.filter(permissao => permissao)
											.map(permissao => `
												${permissao.nome || ''}
											`)
											.join('\n')
										}
									`)
									.join('\n')
								}
							`)
								.toUpperCase()
								.includes(pesquisar)
						) {
							return false;
						}

						return true;

					}).length > 0;

		});
	}

	renderModulo(modulo, readOnly) {

		const selecionado = this.moduloSelecionado(modulo);

		return (
			<div
				key={modulo.id}
				style={{
					backgroundColor: '#ffffff',
					border: '1px solid #d9dce1',
					borderRadius: 5,
					marginBottom: 8,
					overflow: 'hidden',
					boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
				}}
			>

				<div
					style={{
						backgroundColor: selecionado
							? '#e8f5eb'
							: '#f2f3f5',
						padding: '8px 12px',
						borderBottom: selecionado
							? '1px solid #cfe6d5'
							: '1px solid #ddd',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between'
					}}
				>

					<div
						className='icheck-success d-inline'
						style={{
							display: 'flex',
							alignItems: 'center'
						}}
					>

						<input
							id={`checkboxModulo${modulo.id}`}
							type='checkbox'
							disabled={!!readOnly}
							checked={selecionado}
							onChange={() =>
								this.alterarModulo(modulo)
							}
						/>

						<label
							htmlFor={`checkboxModulo${modulo.id}`}
							style={{
								marginBottom: 0,
								fontWeight: 'bold',
								cursor: readOnly
									? 'default'
									: 'pointer'
							}}
						>
							{modulo.nome}
						</label>

					</div>

				</div>

				{selecionado ? (

					<div
						style={{
							padding: '4px 12px 8px 30px'
						}}
					>

						{(modulo.telas || [])
							.filter(tela => tela)
							.map(tela =>
								this.renderTela(
									modulo,
									tela,
									readOnly
								)
							)}

					</div>

				) : null}

			</div>
		);
	}

	renderTela(modulo, tela, readOnly) {

		const selecionada = this.telaSelecionada(
			modulo,
			tela
		);

		return (
			<div
				key={tela.id}
				style={{
					borderBottom: '1px solid #ececec',
					padding: '7px 0'
				}}
			>

				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between'
					}}
				>

					<div
						className='icheck-success d-inline'
						style={{
							display: 'flex',
							alignItems: 'center'
						}}
					>

						<input
							id={`checkboxTela${modulo.id}_${tela.id}`}
							type='checkbox'
							disabled={
								!this.moduloSelecionado(modulo)
								|| !!readOnly
							}
							checked={selecionada}
							onChange={() =>
								this.alterarTela(
									modulo,
									tela
								)
							}
						/>

						<label
							htmlFor={`checkboxTela${modulo.id}_${tela.id}`}
							style={{
								marginBottom: 0,
								fontWeight: 'normal',
								cursor: readOnly
									? 'default'
									: 'pointer'
							}}
						>
							{tela.nome}
						</label>

					</div>

				</div>

				{selecionada
					&& (tela.permissoes || [])
						.filter(permissao => permissao)
						.length > 0 ? (

					<div
						style={{
							marginLeft: 28,
							marginTop: 5,
							paddingLeft: 10,
							borderLeft: '2px solid #e3e6ea'
						}}
					>

						{(tela.permissoes || [])
							.filter(permissao => permissao)
							.map(permissao => (

								<div
									key={permissao.id}
									style={{
										padding: '3px 0'
									}}
								>

									<div
										className='icheck-success d-inline'
										style={{
											display: 'flex',
											alignItems: 'center'
										}}
									>

										<input
											id={
												`checkboxPermissao${modulo.id}_${tela.id}_${permissao.id}`
											}
											type='checkbox'
											disabled={
												!selecionada
												|| !!readOnly
											}
											checked={
												this.permissaoSelecionada(
													modulo,
													tela,
													permissao
												)
											}
											onChange={() =>
												this.alterarPermissao(
													modulo,
													tela,
													permissao
												)
											}
										/>

										<label
											htmlFor={
												`checkboxPermissao${modulo.id}_${tela.id}_${permissao.id}`
											}
											style={{
												marginBottom: 0,
												fontWeight: 'normal',
												fontStyle: 'italic',
												fontSize: 12,
												cursor: readOnly
													? 'default'
													: 'pointer'
											}}
										>
											{permissao.nome}
										</label>

									</div>

								</div>
							))}

					</div>

				) : null}

			</div>
		);
	}

	render() {

		const readOnly = this.props.excluir;
		const listaModulo = this.getListaFiltrada();

		return (
			<ContentCard>

				<Form event={this.props.handleSubmit}>

					<div
						style={{
							display: 'flex',
							flexDirection: 'column'
						}}
					>

						<ContentCardBody
							style={{
								overflow: 'visible'
							}}
						>

							<div
								style={{
									position: 'sticky',
									top: 0,
									zIndex: 50,
									backgroundColor: '#ffffff',
									margin: '-8px -8px 8px -8px',
									padding: 8,
									borderBottom: '1px solid #ddd',
									boxShadow: '0 3px 8px rgba(0,0,0,0.08)'
								}}
							>

								<Row>

								<Field
									name='nome'
									component={LabelAndInput}
									label='Nome'
									placeholder='Informe o nome'
									cols='12 12 12 12'
									readOnly={
										readOnly
											? 'readOnly'
											: ''
									}
								/>

								</Row>

								<Row>

								<InputPesquisa
									maxWidth={350}
									minWidth={350}
									cols='12 12 12 12'
									label='Pesquisar acesso'
									value={this.state.pesquisar}
									onChange={value =>
										this.setState({
											...this.state,
											pesquisar: value
										})
									}
								/>

								{!readOnly ? (

									<div
										style={{
											marginTop: 8,
											marginLeft: 8,
											display: 'flex'
										}}
									>

										<a
											className='btn btn-app bg-primary'
											style={{
												marginLeft: 2,
												minWidth: 90
											}}
											onClick={() =>
												this.marcarTodos()
											}
										>
											<i className='fas fa-check-double'></i>
											{' '}Marcar Todos
										</a>

										<a
											className='btn btn-app bg-secondary'
											style={{
												marginLeft: 2,
												minWidth: 100
											}}
											onClick={() =>
												this.desmarcarTodos()
											}
										>
											<i className='fas fa-times'></i>
											{' '}Desmarcar
										</a>

									</div>

								) : null}

								</Row>

							</div>

							<div
								style={{
									backgroundColor: '#f7f8fa',
									border: '1px solid #e1e3e6',
									borderRadius: 4,
									padding: 8,
									overflow: 'visible'
								}}
							>

								{listaModulo.length > 0 ? (

									listaModulo.map(modulo =>
										this.renderModulo(
											modulo,
											readOnly
										)
									)

								) : (

									<div
										style={{
											textAlign: 'center',
											color: '#888',
											padding: 30
										}}
									>
										<i
											className='fas fa-search'
											style={{
												fontSize: 22,
												marginBottom: 8
											}}
										></i>

										<div>
											Nenhum acesso encontrado
										</div>
									</div>

								)}

							</div>

						</ContentCardBody>

						<div
							style={{
								position: 'sticky',
								bottom: 0,
								zIndex: 50,
								backgroundColor: '#ffffff',
								borderTop: '1px solid #ddd',
								padding: '8px 12px',
								boxShadow: '0 -3px 8px rgba(0,0,0,0.08)'
							}}
						>

							<Row alignCenter>

								<Grid cols='6 6 4 3'>

									{this.props.excluir ? (

										<Button
											text='Excluir'
											submit
											type={'danger'}
											icon={'fa fa-trash'}
										/>

									) : (

										<Button
											text='Salvar'
											submit
											type={'success'}
											icon={'fa fa-check'}
										/>

									)}

								</Grid>

								<Grid cols='6 6 4 3'>

									<Button
										text='Voltar'
										type={'warning'}
										icon={'fa fa-chevron-left'}
										event={() =>
											this.props.setModoTela(
												'lista'
											)
										}
									/>

								</Grid>

							</Row>

						</div>

					</div>

				</Form>

			</ContentCard>
		)
	}
}

PerfilAcessoForm = reduxForm({
	form: 'perfilAcessoForm',
	destroyOnUnmount: false
})(PerfilAcessoForm);

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('perfilAcessoForm')(state) || {
		json_acesso: []
	},
	registro: state.perfilAcesso.registro,
	listaModulo: state.perfilAcesso.listaModulo || []
});

const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PerfilAcessoForm);
